export const MARKETPLACE_LIST = {
  SHOPEE: {
    name: 'shopee',
    icon: 'https://storage.googleapis.com/komerce/kompack/marketplace-integration/shopee-logo.png',
    disabled: false,
  },
  TIKTOK_SHOP: {
    name: 'tiktok',
    icon: 'https://storage.googleapis.com/komerce/kompack/marketplace-integration/tiktok-shop-logo.png',
    disabled: false,
  },
  LAZADA: {
    name: 'lazada',
    icon: 'https://storage.googleapis.com/komerce/kompack/marketplace-integration/lazada-logo.png',
    disabled: false,
  },
  TOKOPEDIA: {
    name: 'tokopedia',
    icon: 'https://storage.googleapis.com/komerce/kompack/marketplace-integration/tokopedia-logo.png',
    disabled: true,
  },
  BUKALAPAK: {
    name: 'bukalapak',
    icon: 'https://storage.googleapis.com/komerce/kompack/marketplace-integration/bukalapak-logo.png',
    disabled: true,
  },
}

export const MODAL_TYPE_ICON = {
  WARNING: 'https://storage.googleapis.com/komerce/assets/icons/warning.svg',
  SUCCESS: 'https://storage.googleapis.com/komerce/assets/icons/success.svg',
}

export const MAPPING_WAREHOUSE_STEP = {
  SELECT_WAREHOUSE: 1,
  SELECT_STORE_ADDRESS: 2,
}

export const MAPPING_PATH = {
  'integrasi-marketplace': 'mi:idx',
  'integrasi-marketplace-mapping-product': 'mi:pm',
  'integrasi-marketplace-mapping-variants': 'mi:vm',
}
